import React, { useCallback, useEffect, useRef, useState } from "react";

export type UseChangedStateOnOutsideClickProps = { originalState: boolean };

function useChangedStateOnOutsideClick<T extends Element>() {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<T>(null);

  const handleOutsideClick = useCallback((e: MouseEvent) => {
    if (ref.current && !ref.current.contains(e.target as Node)) {
      setIsOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick, true);
    return () => {
      document.removeEventListener("click", handleOutsideClick, true);
    };
  }, [handleOutsideClick]);

  return { ref, isOpen, setIsOpen };
}

export default useChangedStateOnOutsideClick;
